import React, { useState } from "react";
import { FaTrash, FaArrowLeft, FaPlus, FaMinus } from "react-icons/fa";

const IngredientManager = () => {
  const [ingredient, setIngredient] = useState("Paneer");
  const [currentStock, setCurrentStock] = useState(250);
  const [updateStock, setUpdateStock] = useState(88);
  const [notes, setNotes] = useState("");
  const [mode, setMode] = useState("add"); // "add" or "remove"

  const [history, setHistory] = useState([
    { type: "remove", amount: 88, total: 250, time: "5 days ago" },
    { type: "add", amount: 88, total: 338, time: "5 days ago" },
    { type: "remove", amount: 88, total: 250, time: "5 days ago" },
  ]);

  const handleSave = () => {
    const newTotal =
      mode === "add"
        ? currentStock + Number(updateStock)
        : currentStock - Number(updateStock);

    const newEntry = {
      type: mode,
      amount: Number(updateStock),
      total: newTotal,
      time: "Just now", // placeholder time
    };

    setHistory([newEntry, ...history]);
    setCurrentStock(newTotal);
    setUpdateStock(0);
    setNotes("");
  };

  return (
    <div className=" flex justify-center h-screen items-start md:items-center p-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-6 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          {/* <FaArrowLeft className="text-gray-600 cursor-pointer" /> */}
          <h1 className="text-xl font-semibold">Ingredient</h1>
          {/* <FaTrash className="text-red-500 cursor-pointer" /> */}
        </div>

        {/* Ingredient Name */}
        <div>
          <label className="text-sm font-medium">Ingredient Name</label>
          <input
            type="text"
            value={ingredient}
            onChange={(e) => setIngredient(e.target.value)}
            className="w-full mt-1 px-3 py-2 border rounded-md text-sm"
          />
        </div>

        {/* Stock Info */}
        <div>
          <label className="text-sm font-medium">Stock</label>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mt-1">
            <p className="text-lg font-bold">
              {currentStock}{" "}
              {mode === "add" ? (
                <span className="text-green-600">+ {updateStock}</span>
              ) : (
                <span className="text-primary">- {updateStock}</span>
              )}
            </p>
            <div className="flex gap-2 w-full sm:w-auto">
              <button
                onClick={() => setMode("add")}
                className={`flex-1 sm:flex-none px-4 py-2 rounded-md text-sm ${
                  mode === "add"
                    ? "bg-green-500 text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
              >
                Add Stock (+)
              </button>
              <button
                onClick={() => setMode("remove")}
                className={`flex-1 sm:flex-none px-4 py-2 rounded-md text-sm ${
                  mode === "remove"
                    ? "bg-red-500 text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
              >
                Remove Stock (−)
              </button>
            </div>
          </div>
        </div>

        {/* Updated Stock Input */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <span
              className={`w-8 h-8 rounded-full flex items-center justify-center text-white ${
                mode === "add" ? "bg-green-500" : "bg-red-500"
              }`}
            >
              {mode === "add" ? <FaPlus /> : <FaMinus />}
            </span>
            <input
              type="number"
              value={updateStock}
              onChange={(e) => setUpdateStock(e.target.value)}
              className="w-full px-3 py-2 border rounded-md text-sm"
            />
          </div>
          <input
            type="text"
            placeholder={`Add Notes (${updateStock} Stocks)`}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="w-full px-3 py-2 border rounded-md text-sm"
          />
        </div>

        {/* Stock History */}
        <div className="mt-4">
          <h2 className="text-sm font-medium mb-2">Stock History</h2>
          <div className="space-y-2 max-h-60 overflow-y-auto pr-1">
            {history.map((entry, index) => (
              <div
                key={index}
                className="flex items-center justify-between bg-gray-50 border p-2 rounded-md"
              >
                <div className="flex items-center gap-2">
                  <span
                    className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-xs ${
                      entry.type === "add" ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    {entry.type === "add" ? "+" : "−"}
                  </span>
                  <div>
                    <p
                      className={`text-sm font-medium ${
                        entry.type === "add"
                          ? "text-green-600"
                          : "text-primary"
                      }`}
                    >
                      {entry.amount} {entry.type === "add" ? "Added" : "Removed"}
                    </p>
                    <p className="text-xs text-gray-500">{entry.time}</p>
                  </div>
                </div>
                <p className="text-sm font-semibold text-gray-800">
                  = {entry.total}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="w-full bg-primary text-white py-2 rounded-md font-semibold text-sm"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default IngredientManager;
